import { useEffect, useState } from 'react'
import usePaymentsApiContext from '@contexts/paymentsApiContext'
import { colors, size } from '@styles/theme'
import useLoading from '@hooks/useLoading'
import styled from '@emotion/styled'
import BackTopbar, { TopbarClearfix } from '@elements/BackTopbar'
import { PiArrowLeftBold, PiSealCheckBold } from 'react-icons/pi'
import UpdatePaymentMethodForm from './UpdatePaymentMethodForm'
import { PositionedTopProgress } from '@elements/Loaders'
import ModalContainer from '@elements/ModalContainer'
import { Elements } from '@stripe/react-stripe-js'
import { ButtonBase } from '@mui/material'
import { Link } from 'react-router-dom'

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const UpdateSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;
  padding-bottom: ${size(15)};
`

const UpdateSuccessButton = styled(ButtonBase)`
  padding: ${size(2)} ${size(4)};
  border-radius: 100px;
  font-weight: 600;
  margin-top: ${size(2)};
  background-color: ${colors.success(500)};
`

const UpdatePaymentMethodModal = ({ isOpen, setClosed }) => {
  const { isLoading: isSubmitLoading, setIsLoading: setIsSubmitLoading, isLoadingDelayed: isSubmitLoadingDelayed } = useLoading(false, 500)
  const { getPaymentsPromise, createSetupIntent, paymentsPromise } = usePaymentsApiContext()
  const { isLoading, setIsLoading, isLoadingDelayed } = useLoading(false)
  const [isUpdateSuccessful, setIsUpdateSuccessful] = useState(false)
  const [clientSecret, setClientSecret] = useState(null)

  useEffect(() => {
    setIsLoading(true)
    getPaymentsPromise()
      .then(() => createSetupIntent())
      .then((res) => {
        setIsLoading(false)
        setClientSecret(res.data.clientSecret)
      })
      .catch((err) => {
        setIsLoading(false)
        // TODO: add snackbar here
        console.log(err.response)
      })
  }, [])

  const renderLoader = () => {
    <h3>Setting up new card...</h3>
  }

  const renderForm = () => {
    if (paymentsPromise && clientSecret && !isLoading) return (
      <>
        <h2>Add New Information</h2>
        <br />
        <Elements stripe={paymentsPromise} options={{ clientSecret, appearance: { variables: { colorText: '#ffffff' } } }}>
          <UpdatePaymentMethodForm
            clientSecret={clientSecret}
            isLoading={isSubmitLoading}
            setIsLoading={setIsSubmitLoading}
            setIsUpdateSuccessful={setIsUpdateSuccessful}
          />
        </Elements>
      </>
    )
  }

  const renderUpdateSuccess = () => (
    <UpdateSuccessContainer>
      <PiSealCheckBold fill={colors.success(500)} size={size(8)} />
      <h2>Update Successful</h2>
      <UpdateSuccessButton
        to={-1}
        component={Link}>
        <PiArrowLeftBold />
        &nbsp;Go Back
      </UpdateSuccessButton>
    </UpdateSuccessContainer>
  )

  const renderUpdateContents = () => {
    if (isLoadingDelayed) return (
      renderLoader()
    ); else if (isUpdateSuccessful) return (
      renderUpdateSuccess()
    ); else return (
      renderForm()
    )
  }

  return (
    <ModalContainer
      noHeader
      open={isOpen}
      setClosed={setClosed}>
      <PositionedTopProgress
        isLoadingDelayed={isLoadingDelayed || isSubmitLoadingDelayed}
        style={{ zIndex: 5 }}
      />
      <BackTopbar
        stopNavigation={isSubmitLoading}
        title='Update Card'
      />
      <TopbarClearfix />
      <Container>
        {renderUpdateContents()}
      </Container>
    </ModalContainer>
  )
}

export default UpdatePaymentMethodModal
